import { Box, BoxProps, Button , ButtonProps as MuiButtonProps} from '@mui/material';

export interface UpdateButtonProps {
    cancelButtonProps?: MuiButtonProps;
    confirmButtonProps?: MuiButtonProps; 
    cancelTitle?: string;
    confirmTitle?: string;
    containerProps?: BoxProps; 
}

const UpdateButton = (props:UpdateButtonProps) => {
  return (
    <Box p={2} gap={2} display={'flex'} alignItems={'center'} justifyContent={'center'} {...props.containerProps}>
        <Button variant="outlined"  color="primary" {...(props.cancelButtonProps)}>
        {props.cancelTitle ?? "Back"}
      </Button>
      <Button  variant="contained" color="primary" {...(props.confirmButtonProps)}>
        {props.confirmTitle ?? "Next"}
      </Button> 
    </Box>
  )
}

export default UpdateButton